import React from 'react';
import generations from '../images/infographic1/related-content/generations.jpg';
import pie from '../images/infographic1/related-content/pie.png';
import psychology from '../images/infographic1/related-content/psychology.jpg';
import alaska from '../images/infographic1/related-content/alaska.png';
import pencil from '../images/wealthdiaries.jpg';
import mdh from '../images/maahdaahheythumbnail.jpg';
import goh from '../images/gameofhappythumbnail.png';
import map from '../images/map.jpg';
import cac from '../images/calmaftercrisis.jpg';
import '../stylesheets/ArticleLinks.scss';

function ArticleLinks(props) {
  const location = window.location.href.endsWith('/') ? window.location.href.substring(0, window.location.href.length - 1) : window.location.href;

  const locationSplit = location.split('/');
  const firstArticleId = locationSplit.includes('interactive') ? locationSplit[5] : locationSplit[3];

  return (
    <div className="article-links-wrapper">
      <h4 className="title">More from John Hancock</h4>
      <div className="article-links-container">
        {firstArticleId !== 'psychology-of-wealth' && (
          <div className="tab1">
            <a className="wrapper" href={`${props.stagingUrl}psychology-of-wealth/`}>
              <img src={psychology} alt="psychology of wealth" />
              <h4>Psychology of Wealth</h4>
              <p>How understanding the psychology of wealth can help you scale the happiness pyramid.</p>
            </a>
          </div>
        )}
        {firstArticleId !== 'pie-in-the-sky' && (
          <div className="tab2">
            <a className="wrapper" href={`${props.stagingUrl}pie-in-the-sky/`}>
              <img src={pie} alt="Pie In The Sky" />
              <h4>Pie In The Sky</h4>
              <p>
                For the Elsen sisters, wealth became more than money when they opened their pie shop, Four & Twenty Blackbirds. Watch to see how they are reimagining wealth for
                themselves and their business.
              </p>
            </a>
          </div>
        )}
        {firstArticleId !== 'wild-in-alaska' && (
          <div className="tab3">
            <a className="wrapper" href={`${props.stagingUrl}wild-in-alaska/`}>
              <img src={alaska} alt="Wild in Alaska" />
              <h4>Wild In Alaska</h4>
              <p>
                Emma and Claire, Salmon Sisters Founders, are focused on commercial fishing and supporting their community. See how they are reimagining wealth for themselves and
                fellow Alaskans.
              </p>
            </a>
          </div>
        )}

        {firstArticleId !== 'generations-of-wealth' && (
          <div className="tab4">
            <a className="wrapper" href={`${props.stagingUrl}generations-of-wealth/`}>
              <img src={generations} alt="Generations of Wealth" />
              <h4>Generations of Wealth</h4>
              <p>How Millennials, Gen X and Baby Boomers spend, save and think about wealth.</p>
            </a>
          </div>
        )}
        {firstArticleId !== 'the-wealth-diaries' && (
          <div className="tab5">
            <a className="wrapper" href={`${props.stagingUrl}the-wealth-diaries/`}>
              <img src={pencil} alt="The Wealth Diaries" />
              <h4>Wealth Diaries</h4>
              <p>Meet five people who are on a winding journey toward financial freedom and learn how they are reimagining wealth along the way.</p>
            </a>
          </div>
        )}
        {firstArticleId !== 'saving-the-maah-daah-hey' && (
          <div className="tab6">
            <a className="wrapper" href={`${props.stagingUrl}saving-the-maah-daah-hey/`}>
              <img src={mdh} alt="Maah Daah Hey" />
              <h4>Saving the Maah Daah Hey</h4>
              <p>
                For Nick and Lindsey Ybarra, the Maah Daah Hey Trail is a place where people come together. See how the Ybarras are reimagining wealth by making an impact on their
                community.
              </p>
            </a>
          </div>
        )}
        {firstArticleId !== 'the-game-of-happy' && (
          <div className="tab7">
            <a className="wrapper" href={`${props.stagingUrl}the-game-of-happy/`}>
              <img src={goh} alt="Maah Daah Hey" />
              <h4>The Game of Happy</h4>
              <p>
                Trying to get ahead in life sometimes feels like being stuck in a board game. But playing it strictly by the numbers can set you back when it comes to reaching your
                ultimate goal.
              </p>
            </a>
          </div>
        )}
        {firstArticleId !== 'calm-after-crisis' && (
          <div className="tab8">
            <a className="wrapper" href={`${props.stagingUrl}calm-after-crisis/`}>
              <img src={cac} alt="Maah Daah Hey" />
              <h4>Calm After Crisis</h4>
              <p>
                After Devoting His Life To Service, Manny Salazar Is Reimagining What Wealth Really Means. See How Manny’s Healing Journey Led Him To Discover A New Purpose In
                Life.
              </p>
            </a>
          </div>
        )}
        {firstArticleId !== 'map' && (
          <div className="tab9">
            <a className="wrapper" href={`http://sponsorcontent.cnn.com/interactive/john-hancock/map/`}>
              <img src={map} alt="Maah Daah Hey" />
              <h4>ReImagining Wealth Across America</h4>
              <p>See how all 50 states define true wealth and prioritize their personal finances.</p>
            </a>
          </div>
        )}
        {/* {firstArticleId !== 'the-game-of-happy' && (
          <div className="tab8">
            <a className="wrapper" href={`${props.stagingUrl}the-game-of-happy/`}>
              <img src={goh} alt="Maah Daah Hey" />
              <h4>Calm After Crisis</h4>
              <p>
                Trying to get ahead in life sometimes feels like being stuck in a board game. But playing it strictly by the numbers can set you back when it comes to reaching your
                ultimate goal.
              </p>
        {firstArticleId !== 'map' && (
          <div className="tab9">
            <a className="wrapper" href={`http://courageous-john-hancock-interactive-map-staging.s3-website-us-east-1.amazonaws.com/`} target="_blank" rel="noopener noreferrer">
              <img src={map} alt="Maah Daah Hey" />
              <h4>ReImagining Wealth Across America</h4>
              <p>See how all 50 states define true wealth and prioritize their personal finances.</p>
            </a>
          </div>
        )} */}
      </div>
    </div>
  );
}

export default ArticleLinks;
